module.exports = __webpack_public_path__ + "img/pp.bcf9b85e.jpg";